<template>
  <div class="regist_group_box">
    <el-form
      :model="query"
      ref="formLeft"
      style="margin: 0 30px 60px 0;"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="教练员" prop="coachId">
        <el-select
          :popper-append-to-body="false"
          :disabled="isDisabled"
          style="width:232px"
          v-model="query.coachId"
          @change="selectCoach"
        >
          <el-option
            v-for="(item,index) in coachList"
            :key="index"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="应急联系人" prop="urgentName">
        <el-input :disabled="isDisabled" v-model="query.urgentName" placeholder="请输入联系人姓名"></el-input>
      </el-form-item>
    </el-form>
    <el-form :model="query" ref="formRight" :rules="rules" label-width="112px">
      <el-form-item label="教练员电话">
        <el-input style="width:217px" disabled placeholder="选择教练员后自动填充" v-model="query.coachPhone"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="urgentPhone">
        <el-input :disabled="isDisabled" v-model="query.urgentPhone" placeholder="请输入联系电话"></el-input>
      </el-form-item>
    </el-form>
    <el-form
      class="contact_address"
      ref="formBottom"
      :model="query"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="应急人地址" prop="urgentAddress">
        <el-input :disabled="isDisabled" v-model="query.urgentAddress" placeholder="请输入应急人地址"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import registerData from "@/assets/json/register.json";
import { rule } from "@/utils/utils";
export default {
  props: {
    coachList: {
      type: Array
    },
    formInfo: {
      type: Object
    },
    operation: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      query: {
        coachId: "",
        urgentName: "",
        coachPhone: "",
        urgentPhone: "",
        urgentAddress: ""
      },
      rules: {
        coachId: [
          { required: true, message: "教练员不能为空", trigger: "change" }
        ],
        urgentName: [
          { required: true, message: "应急联系人不能为空", trigger: "blur" }
        ],
        urgentPhone: [
          { required: true, validator: rule.phone, trigger: "blur" }
        ],
        urgentAddress: [
          { required: true, message: "应急人地址不能为空", trigger: "blur" }
        ]
      }
    };
  },
  watch: {
    formInfo(value) {
      if (value) {
        for (let item in value) {
          if (this.query.hasOwnProperty(item))
            this.$set(this.query, item, value[item]);
        }
        this.selectCoach(this.query.coachId);
      }
    }
  },
  computed: {
    // 判断是否禁用表单组件输入
    isDisabled() {
      if (this.operation) {
        if (this.operation === "watch") return true;
        else {
          if (this.formInfo && this.formInfo.name) {
            if (
              this.formInfo.state === 0 ||
              this.formInfo.state === 2 ||
              this.formInfo.state === 4
            ) {
              return false;
            } else {
              return true;
            }
          }
        }
      }
      return false;
    },
    groupList() {
      return this.query.type === 1
        ? registerData.sportsProjectList
        : registerData.sunshineProject;
    },
    registGroup() {
      return registerData.registGroup;
    }
  },
  methods: {
    // 选择教练员后获取对应电话填入
    selectCoach(value) {
      this.coachList.filter(item => {
        if (item.id === value) {
          this.query.coachPhone = item.phone;
        }
      });
    },
    // 表单提交验证
    submits() {
      return Promise.all([
        this.$refs["formLeft"].validate(),
        this.$refs["formRight"].validate(),
        this.$refs["formBottom"].validate()
      ])
        .then(res => {
          return Promise.resolve(this.query);
        })
        .catch(err => {
          this.$message.warning("请完善联系人信息");
          return null;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.regist_group_box {
  display: flex;
  position: relative;
  /deep/ .contact_address {
    position: absolute;
    bottom: 0px;
    width: 711px;
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: #606266;
  }
}
</style>